//:options="this.merch.map(merch => merch.name + ' - ' + merch.size + ' - ' + '$' + merch.price)"

<template>
  <div>
      <div style="padding: 10px">
        <v-select :value="this.merch.find(elem => item.item != null && elem.label == item.item.label)" @input="updateMerch($event)" style="width: 250px; display: inline-block" :options="merch"></v-select>
      </div>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css"
import vSelect from 'vue-select'

export default {
    components: {
        vSelect
    },
    props: {
        merch: {
            type: Array
        },
        item: {
            type: Object
        }
    },
    data() {
        return {

        }
    },
    methods: {
        updateMerch(value) {
            this.item["item"] = value
            this.$emit('valueChanged')
        }
    }
}
</script>

<style>

</style>